/**
 * Bug #489
 * @Author Anupama P
 * @Date 9 Jul 2021
 */
import { Button, FontAwesomeIcon, faPlusCircle } from 'components'
import styles from './style/styles.module.scss';

export default function AddMoreButton(props) {
    return (
        <Button
            type="text"
            className={styles.addMoreButton}
            icon={<FontAwesomeIcon icon={faPlusCircle} className={styles.addMoreIcon} />}
            {...props}
        >
            Add More
        </Button>
    )
}
